import type { ReactNode } from 'react'

import { Slider, type TSliderProps } from '@/src/elements/slider/Slider'
import type { TGetCommunitiesApiData } from '@/src/features/community/api/getCommunities.types'
import type { EVENT_ORIGIN } from '@/src/features/community/models/community.constants'
import { CommunityCard } from '@/src/features/community/ui/components/CommunityCard'
import type { TCommunityCardVariant } from '@/src/features/community/ui/components/CommunityCard/CommunityCard.types'
import type { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'

type TCommunityItem = TGetCommunitiesApiData[number]

export type TCommunityCardSliderProps = Omit<
  TSliderProps<TCommunityItem>,
  'renderItem' | 'renderPlaceholderItem' | 'getItemKey' | 'classes'
> & {
  classes?: TSliderProps<TCommunityItem>['classes'] & { card?: string }
  origin: EVENT_ORIGIN
  source: TRACKING_SOURCE
  showSubscribeButton?: boolean
  communityCardTestId?: string
  onPress?: VoidFunction
  communityCardVariant?: TCommunityCardVariant
}

export const CommunityCardSlider = ({
  classes: { card, ...sliderClasses } = {},
  showSubscribeButton = false,
  origin,
  source,
  communityCardTestId,
  onPress,
  communityCardVariant,
  ...props
}: TCommunityCardSliderProps): ReactNode => (
  <Slider
    {...props}
    classes={sliderClasses}
    getItemKey={(item) => item.id}
    renderItem={(item) => (
      <CommunityCard
        onCustomCardPress={onPress}
        testId={communityCardTestId}
        community={{ hasJoined: false, ...item }}
        origin={origin}
        source={source}
        showSubscribeButton={showSubscribeButton}
        className={card}
        variant={communityCardVariant}
      />
    )}
  />
)
